import { type InputHTMLAttributes, forwardRef } from 'react';

import { cn } from '~/lib/utils.ts';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-8 w-full rounded-[4px] border border-[color:var(--border-default)] bg-[color:var(--bg-canvas)] px-3 text-sm',
        'text-[color:var(--fg-primary)] placeholder:text-[color:var(--fg-tertiary)]',
        'focus-visible:outline-none focus-visible:border-[color:var(--accent)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
});
